import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";
import { localizeAndList } from "../../Utils/LocalizationUtils";
import { FormattedMessage, IFormattedMessageLink } from "../../../../Intercom.ReactUI/Views/FormattedMessage";

export interface TermsOfServiceDialogProps {
    className?: string;
    header: string;
    message?: string;
    noticeMessage?: string;
    checkboxes: string[];
}

export interface TermsOfServiceDialogState {
    agreeButtonEnabled: boolean,
    checkboxStates: boolean[],
}

export const TermsOfServiceLinks = {
    "azure": "https://go.microsoft.com/fwLink/?LinkID=522330",
    "privacy": "https://privacy.microsoft.com/en-us/privacystatement",
    "cortana": "https://aka.ms/bots/terms/knowledge",
    "combined": "https://aka.ms/bots/terms/channels",
}
export const CurrentTermsOfServiceStrings = {
    "cortana": "cortana-december2017",
    "msteams": "msteams-december2017",
    "skype": "skype-december2017",
    "skypeforbusiness": "skypeforbusiness-december2017",
}

export class TermsOfServiceDialog extends React.Component<TermsOfServiceDialogProps, TermsOfServiceDialogState> {
    constructor(props: TermsOfServiceDialogProps) {
        super(props);

        let relevantCheckboxes = props.checkboxes;
        const channelsToCombine = props.checkboxes.filter((val) => ["skype", "skypeforbusiness", "msteams"].indexOf(val) >= 0);
        if (channelsToCombine.length > 0) {
            relevantCheckboxes = props.checkboxes.filter((val) => ["skype", "skypeforbusiness", "msteams"].indexOf(val) < 0);
            relevantCheckboxes.push("combined");
        }
        const checkboxStates = relevantCheckboxes.map(() => false);

        this.state = {
            agreeButtonEnabled: false,
            checkboxStates: checkboxStates
        };
    }

    private checkboxesUpdate(value: boolean, i: number): void {
        const checkboxes = this.state.checkboxStates;
        checkboxes[i] = value;
        this.setState({
            agreeButtonEnabled: checkboxes.indexOf(false) < 0,
            checkboxStates: checkboxes
        });
    }

    private checkboxTexts = {
        "azure": Resources.tosDialog_AzureTermsCheckbox,
        "cortana": Resources.tosDialog_CortanaTermsCheckbox,
        "combined": "",
    }
    private termsLinkTexts = {
        "azure": Resources.tosDialog_ABSTerms,
        "cortana": Resources.tosDialog_MSKnowledgeGraphTerms,
        "combined": Resources.tosDialog_MSPublicationTerms,
    }
    private channelNames = {
        "msteams": Resources.MicrosoftTeams,
        "skype": Resources.Skype,
        "skypeforbusiness": Resources.SkypeforBusiness,
    }

    /** Renders Terms of Services checkboxes for Azure and certain channels */
    private renderCheckboxes(): JSX.Element[] {
        let checkboxes:string[] = this.props.checkboxes;
        
        // figures out how to combine the three channels that share terms
        let channelsToCombine:string[] = checkboxes.filter((val) => ["skype", "skypeforbusiness", "msteams"].indexOf(val) >= 0);
        if (channelsToCombine.length > 0) {
            checkboxes = checkboxes.filter((val) => ["skype", "skypeforbusiness", "msteams"].indexOf(val) < 0);
            const baseResource = channelsToCombine.length === 1 ? Resources.tosDialog_CombinedTermsCheckboxOneChannel : Resources.tosDialog_CombinedTermsCheckboxMultiChannels;
            const channelNamesList = channelsToCombine.map(channel => this.channelNames[channel]);

            this.checkboxTexts.combined = _.template(baseResource)({"channelslist": localizeAndList(channelNamesList)});
            checkboxes.push("combined");
        }

        return checkboxes.map((checkbox, i) => {
            if (this.checkboxTexts[checkbox]) {
                const links:IFormattedMessageLink[] = [
                    {
                        text: this.termsLinkTexts[checkbox],
                        href: TermsOfServiceLinks[checkbox],
                        target: "_blank"
                    }, {
                        text: Resources.tosDialog_MSPrivacyStatement,
                        href: TermsOfServiceLinks.privacy,
                        target: "_blank"
                    }
                ]
                return (
                    <div className={"tos-checkbox"} key={checkbox+"TOS"}>
                        <label className={"m-checkbox-container"}>
                            <div className={"tos-checkbox-alignment"}>
                                <input className={"m-checkbox"} type="checkbox" onChange={ev => this.checkboxesUpdate(ev.target.checked, i)}/>
                                <span className={"m-icon-Checkbox unchecked"}></span>
                                <span className={"m-icon-CheckboxComposite checked"}></span>
                                <FormattedMessage
                                    message={this.checkboxTexts[checkbox]}
                                    links={links}
                                    className={"migration-checkbox-blurb"}
                                />
                            </div>
                        </label>
                    </div>
                );
            }
        });
    }

    private renderMessageText(): JSX.Element {
        const elements = [<span key="message">{this.props.message}</span>]
        if (this.props.noticeMessage) {
            elements.push(<b key="notice">{Resources.notice}</b>);
            elements.push(<span key="notice-text">{this.props.noticeMessage}</span>)
        }
        return <p className="message-box-message">{elements}</p>;
    }

    render() {
        return (
            <div className={"terms-of-service-dialog " + (this.props.className || '')}>
                <h2>{this.props.header}</h2>
                {this.props.message ? this.renderMessageText() : null}
                {this.renderCheckboxes()}
                <div className="button-panel">
                    <button type="button" className="cancel-button m-button-secondary-md">{Resources.cancelButtonText}</button>
                    <button type="submit" className="ok-button m-button-primary-md" disabled={!this.state.agreeButtonEnabled}>Agree</button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/TermsOfServiceDialog.tsx